import { PosBadge } from './Badge.jsx';

function formatDate(value) {
  if (!value) return '';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '';
  return d.toISOString().slice(0, 10);
}

function daysBetween(targetISO, todayISO) {
  if (!targetISO) return null;
  const a = new Date(targetISO + 'T00:00:00');
  const b = new Date(todayISO + 'T00:00:00');
  if (Number.isNaN(a.getTime()) || Number.isNaN(b.getTime())) return null;
  return Math.round((b - a) / (1000 * 60 * 60 * 24));
}

function probabilityTone(p) {
  if (p == null) return 'grey';
  if (p >= 70) return 'green';
  if (p >= 30) return 'amber';
  return 'red';
}

function ProbabilityBadge({ value }) {
  if (value == null) return <span className="cell-muted">—</span>;
  return <span className={`badge badge-${probabilityTone(value)}`}>{value}%</span>;
}

export default function FollowUpCard({ lead, todayISO, onClick }) {
  const days = daysBetween(formatDate(lead.next_contact), todayISO);
  const isOverdue = days != null && days > 0;
  const isToday = days === 0;
  const urgency = isOverdue ? 'overdue' : isToday ? 'today' : 'upcoming';
  const location = [lead.city, lead.province_state].filter(Boolean).join(', ');
  const contactName = [lead.first_name, lead.last_name].filter(Boolean).join(' ');
  // Prefer the main site line; fall back to the cell. Shown beside the
  // company name so a rep can call straight off the card.
  const phone = lead.phone_main || lead.phone_cell || '';

  return (
    <button type="button" className={`followup-card followup-${urgency}`} onClick={onClick}>
      <div className="followup-head">
        <div className="followup-title">
          {lead.company || contactName || `Lead #${lead.id}`}
          {phone && <span className="followup-phone cell-mono">{phone}</span>}
        </div>
        <ProbabilityBadge value={lead.close_probability} />
      </div>
      <div className="followup-meta">
        {lead.site_number && <span className="cell-mono">Site #{lead.site_number}</span>}
        {lead.pos_type && <><span className="sep" /><PosBadge value={lead.pos_type} /></>}
        {location && <><span className="sep" />{location}</>}
        {contactName && lead.company && <><span className="sep" />{contactName}</>}
      </div>
      <div className="followup-foot">
        <span className={`followup-status followup-status-${urgency}`}>
          {isOverdue && `${days} day${days === 1 ? '' : 's'} overdue`}
          {isToday && 'Due today'}
          {!isOverdue && !isToday && days != null && `In ${Math.abs(days)} days`}
        </span>
        <span className="cell-mono followup-date">{formatDate(lead.next_contact)}</span>
      </div>
    </button>
  );
}
